import React from 'react'

import Link from '@Pure/Link'

import _ from 'lodash'

export const form =
{
	model: 'AdBlog'.toLowerCase(),
	name: 'AdBlog'.toLowerCase(),

	form_title: 'Article de blog promotion',

	fields:
	{
		title:
		{
			label: 'Titre'
		},

		date:
		{
			label: 'Date de l\'article',
			type: 'date'
		},

		disabled:
		{
			label: 'Désactiver l\'article',
			type: 'checkbox',
			front_indicator: true
		},

		youtube:
		{
			label: 'Vidéos YouTube',
			youtube: true,
			repeatable: false,
			front_indicator: true
		},

		images:
		{
			label: 'Images',
			type: 'image',
			multiple: true
		},

		content:
		{
			label: 'Contenu',
			type: 'editor',
			images: true
		},

		pdfs:
		{
			label: 'PDFs',
			type: 'pdf',
			multiple: true
		}
	},

	create_label: 'Créer cet article',

	hookComponentWillMount: function ()
	{
		const component = this, props = this.props, state = this.state;

		let form_data = component.state.form_data;

		form_data['adblog[type]'] = 'EC';

		component.setState(
		{
			form_data: form_data
		});
	},

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cet article&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['adblog[title]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		let link = '/gestion-des-CE/blog-promos/';

		if (model.EC)
		{
			link = '/accueil/mon-espace/blog-promos/';
		}

		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouvel article <strong> { model.title } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ link + model.id }>
						Voir l'article
					</Link>
				</div>
			</div>
		);

		return output;
	}
};

export const list =
{
	model: 'AdBlog'.toLowerCase(),
	title: 'Liste des articles de blog promotion',
	link: '/gestion-des-CE/blog-promos',
	creation_link: '/gestion-des-CE/blog-promos/nouvel-article',
	creation_label: 'Nouvel article',
	header_map:
	{
		'Titre': 'title',
		'Date': 'date'
	},
	row_link_base: '/gestion-des-CE/blog-promos/',
	searched_prop: 'title'
};

let config =_.merge(_.cloneDeep(form), list);

export default config